import React, { useEffect } from 'react';
import Logo from 'components/common/logo';
import { Link, useHistory } from 'react-router-dom';
import logoRobot from 'style/imgs/logo_robot.svg';
import firstStep from 'style/imgs/first_step.svg';
import secondStep from 'style/imgs/second_step.svg';
import thirdStep from 'style/imgs/third_step.svg';
import fourthStep from 'style/imgs/fourth_step.svg';
import { IRootState } from 'store';
import { connect } from 'react-redux';
import MobileService from 'services/mobile';
import buttons from 'style/buttons.module.scss';
import styles from './index.module.scss';

const mapStateToProps = (state: IRootState) => ({
  units: state.scholars.units,
  rootLink: state.auth.rootLink,
});

type IProps = ReturnType<typeof mapStateToProps>;

const Steps: React.FC<IProps> = ({ units, rootLink }) => {
  const history = useHistory();
  const linksDisabled = !units || units.length === 0;

  useEffect(() => {
    if (rootLink === '/registration-success') {
      history.push(rootLink);
    }
  }, [rootLink, history]);

  return (
    <div className={styles.root}>
      <div className={styles.logo}>
        <img src={logoRobot} alt="logo_robot" />
        <Logo />
      </div>
      <h1 className="deep-gray-heading">Let’s Get Started</h1>
      <div className={styles.selectBlock}>
        <Link
          to="/onboarding/profile"
          className={`${styles.selectBlockItemBottom} ${styles.trapezoid} ${
            MobileService.isMobile ? styles.tablet : ''
          }`}
        >
          <div>
            <div>
              <img src={firstStep} alt="teacher" />
            </div>
            <span className="message-title">1. Create Scholar Profile</span>
            <p className="message-text">
              Create a profile for your scholar and set permissions to determine
              their ability to edit their learning workflow and their digital
              resources
            </p>
          </div>
        </Link>
        <Link
          to="/onboarding/choose-map/"
          className={`${styles.selectBlockItemTop} ${styles.trapezoid} ${
            linksDisabled && styles.linkDisabled
          } ${MobileService.isMobile ? styles.tablet : ''}`}
        >
          <div>
            <div>
              <img src={secondStep} alt="parent" />
            </div>
            <span className="message-title">2. Choose Map Template</span>
            <p className="message-text">
              Select a template from the library that will delight your scholar.
            </p>
          </div>
        </Link>
        <Link
          to="/onboarding/timetable"
          className={`${styles.selectBlockItemBottom} ${styles.trapezoid} ${
            linksDisabled && styles.linkDisabled
          } ${MobileService.isMobile ? styles.tablet : ''}`}
        >
          <div>
            <div>
              <img src={thirdStep} alt="teacher" />
            </div>
            <span className="message-title">
              3. Add Timetable and Web Addresses
            </span>
            <p className="message-text">
              Add a schedule, and the web addresses to any digital resources
              your scholar uses.
            </p>
          </div>
        </Link>
        <Link
          to="/dashboard/scholars"
          className={`${styles.selectBlockItemTop} ${styles.trapezoid} ${
            MobileService.isMobile ? styles.tablet : ''
          }`}
        >
          <div>
            <div>
              <img src={fourthStep} alt="parent" />
            </div>
            <span className="message-title">4. Go To Parent’s Dashboard</span>
            <p className="message-text">
              See an overview of all your scholars and keep track of their
              digital locations from one screen. Manage your Aneta account.
            </p>
          </div>
        </Link>
      </div>
      <button
        type="button"
        onClick={() => history.push('/onboarding/profile')}
        className={buttons.buttomPrimary}
      >
        Let’s Go
      </button>
    </div>
  );
};

export default connect(mapStateToProps)(Steps);
